import { render, staticRenderFns } from "./BrowserNotSupport.vue?vue&type=template&id=2272742b&"
import script from "./BrowserNotSupport.vue?vue&type=script&lang=js&"
export * from "./BrowserNotSupport.vue?vue&type=script&lang=js&"
import style0 from "./BrowserNotSupport.vue?vue&type=style&index=0&id=2272742b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports